<ng-container *ngIf="icon">
    <ng-container *ngIf="routerLink; else regularIconButton">
        <button
            mat-ripple
            class="ds-button ds-icon-button"
            [disabled]="isDisabled"
            [ngClass]="buttonClasses"
            [queryParams]="queryParams"
            [routerLink]="routerLink"
            [routerLinkActive]="routerLink ? 'active' : null"
        >
            <mat-icon [fontSet]="iconFontSet">{{ icon }}</mat-icon>
        </button>
    </ng-container>

    <ng-template #regularIconButton>
        <button mat-ripple class="ds-button ds-icon-button" [disabled]="isDisabled" [ngClass]="buttonClasses" (click)="buttonClick.emit()">
            <mat-icon [fontSet]="iconFontSet">{{ icon }}</mat-icon>
        </button>
    </ng-template>
</ng-container>
